"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserFeedbacksByTypeV1FeedbackTypeEnum = exports.GetAdminFeedbacksV1ReferenceTypeEnum = exports.GetAdminFeedbacksV1FeedbackTypeEnum = exports.CreateAuth0UserV1IdpEnum = exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * AccountApi - axios parameter creator
 */
const AccountApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Block user in Auth0 and place deactivated_at flag in account
         * @summary Block user
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUserV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, userGroup }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('blockUserV1', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/block`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/block`,
                sdkMethod: 'blockUserV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Staging only, admin only. Forwards payload to https://auth0.com/docs/api/management/v2/users/post-users
         * @summary Create a user in Auth0
         * @param {CreateAuth0UserV1IdpEnum} idp The IdP in which to create the user
         * @param {AccountCreateAuth0UserRequest} accountCreateAuth0UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuth0UserV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ idp, accountCreateAuth0UserRequest }, options = {}) {
            // verify required parameter 'idp' is not null or undefined
            (0, common_1.assertParamExists)('createAuth0UserV1', 'idp', idp);
            // verify required parameter 'accountCreateAuth0UserRequest' is not null or undefined
            (0, common_1.assertParamExists)('createAuth0UserV1', 'accountCreateAuth0UserRequest', accountCreateAuth0UserRequest);
            const localVarPath = `/v1/accounts/auth0/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (idp !== undefined) {
                localVarQueryParameter['idp'] = idp;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/auth0/users`,
                sdkMethod: 'createAuth0UserV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountCreateAuth0UserRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Create signed URLs where users can upload photo URL.
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhotoUploadURL: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, userGroup }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('createPhotoUploadURL', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/avatar/upload`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/avatar/upload`,
                sdkMethod: 'createPhotoUploadURL',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Deletes all data related the user.
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountsByUserIdV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, rHGApp, userGroup }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('deleteAccountsByUserIdV1', 'userId', userId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('deleteAccountsByUserIdV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/{user_id}`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}`,
                sdkMethod: 'deleteAccountsByUserIdV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns account information.
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByUserIdV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, rHGApp, userGroup }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getAccountsByUserIdV1', 'userId', userId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getAccountsByUserIdV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/{user_id}`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}`,
                sdkMethod: 'getAccountsByUserIdV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Admin endpoint to fetch feedbacks with optional filtering by user_id, feedback_type, reference_type, and reference_id.
         * @summary Return feedbacks across all users with optional filters
         * @param {string} [userId] Filter by user ID.
         * @param {GetAdminFeedbacksV1FeedbackTypeEnum} [feedbackType] Filter by feedback type.
         * @param {GetAdminFeedbacksV1ReferenceTypeEnum} [referenceType] Filter by reference type.
         * @param {string} [referenceId] Filter by reference ID.
         * @param {string} [dob] Filter by the eligibility field \&#39;dob\&#39; stored in the feedback data.
         * @param {string} [lastName] Filter by the eligibility field \&#39;last_name\&#39; stored in the feedback data (case-insensitive).
         * @param {string} [firstName] Filter by the eligibility field \&#39;first_name\&#39; stored in the feedback data (case-insensitive).
         * @param {string} [subscriberId] Filter by the eligibility field \&#39;subscriber_id\&#39; stored in the feedback data.
         * @param {string} [email] Filter by the eligibility field \&#39;email\&#39; stored in the feedback data (case-insensitive).
         * @param {number} [page] Page number (1-based). Defaults to 5 when not provided.
         * @param {number} [perPage] Number of items per page. Defaults to 10 when not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminFeedbacksV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, feedbackType, referenceType, referenceId, dob, lastName, firstName, subscriberId, email, page, perPage, }, options = {}) {
            const localVarPath = `/v1/accounts/admin/feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (feedbackType !== undefined) {
                localVarQueryParameter['feedback_type'] = feedbackType;
            }
            if (referenceType !== undefined) {
                localVarQueryParameter['reference_type'] = referenceType;
            }
            if (referenceId !== undefined) {
                localVarQueryParameter['reference_id'] = referenceId;
            }
            if (dob !== undefined) {
                localVarQueryParameter['dob'] = dob;
            }
            if (lastName !== undefined) {
                localVarQueryParameter['last_name'] = lastName;
            }
            if (firstName !== undefined) {
                localVarQueryParameter['first_name'] = firstName;
            }
            if (subscriberId !== undefined) {
                localVarQueryParameter['subscriber_id'] = subscriberId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/admin/feedback`,
                sdkMethod: 'getAdminFeedbacksV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return all consents that meet the query parameters.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [cohort] The cohort to consider.
         * @param {string} [role] The role to consider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, cohort, role }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getConsentsV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (cohort !== undefined) {
                localVarQueryParameter['cohort'] = cohort;
            }
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/consents`,
                sdkMethod: 'getConsentsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3 |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get a list of country codes
         * @param {string} [restricted] Set to true to get only restricted country codes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryCodes: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ restricted }, options = {}) {
            const localVarPath = `/v1/accounts/countryCodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (restricted !== undefined) {
                localVarQueryParameter['restricted'] = restricted;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/countryCodes`,
                sdkMethod: 'getCountryCodes',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get a list of supported genders
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGendersV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ acceptLanguage }, options = {}) {
            const localVarPath = `/v1/accounts/genders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/genders`,
                sdkMethod: 'getGendersV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns products a user belongs to.
         * @param {string} userId User Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByUserId: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getProductsByUserId', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/products`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/products`,
                sdkMethod: 'getProductsByUserId',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return the users consent state.
         * @param {string} userId User Id.
         * @param {number} consentId The consent id based on the config that needs to be acted upon.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsentByIdV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, consentId, rHGApp, userGroup, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUserConsentByIdV1', 'userId', userId);
            // verify required parameter 'consentId' is not null or undefined
            (0, common_1.assertParamExists)('getUserConsentByIdV1', 'consentId', consentId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getUserConsentByIdV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/{user_id}/consents/{consent_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{consent_id}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/consents/{consent_id}`,
                sdkMethod: 'getUserConsentByIdV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return all consents for the user along with their consent state.
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsentsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, rHGApp, userGroup }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUserConsentsV1', 'userId', userId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getUserConsentsV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/{user_id}/consents`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/consents`,
                sdkMethod: 'getUserConsentsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return all feedbacks provided by the user given a feedback type
         * @param {string} userId User Id.
         * @param {GetUserFeedbacksByTypeV1FeedbackTypeEnum} feedbackType The type of feedback to return.
         * @param {number} [page] Page number (1-based). Defaults to 1 when not provided.
         * @param {number} [perPage] Number of items per page. Defaults to 10 when not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFeedbacksByTypeV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, feedbackType, page, perPage, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUserFeedbacksByTypeV1', 'userId', userId);
            // verify required parameter 'feedbackType' is not null or undefined
            (0, common_1.assertParamExists)('getUserFeedbacksByTypeV1', 'feedbackType', feedbackType);
            const localVarPath = `/v1/accounts/{user_id}/feedbacks`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (feedbackType !== undefined) {
                localVarQueryParameter['feedback_type'] = feedbackType;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/feedbacks`,
                sdkMethod: 'getUserFeedbacksByTypeV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns user\'s group config.
         * @param {string} userId User Id.
         * @param {AccountApp} app App\&#39;s like mobile, web etc from the enum.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupByUserIdV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, app, rHGApp, userGroup }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('getUserGroupByUserIdV1', 'userId', userId);
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('getUserGroupByUserIdV1', 'app', app);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getUserGroupByUserIdV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/{user_id}/groups/apps/{app}`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{app}', encodeURIComponent(String(app)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/groups/apps/{app}`,
                sdkMethod: 'getUserGroupByUserIdV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns all the group config for the provided parameters.
         * @param {AccountApp} app App\&#39;s like mobile, web etc from the enum.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupsByAppV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ app, rHGApp }, options = {}) {
            // verify required parameter 'app' is not null or undefined
            (0, common_1.assertParamExists)('getUserGroupsByAppV1', 'app', app);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('getUserGroupsByAppV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/groups/apps/{app}`.replace('{app}', encodeURIComponent(String(app)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/groups/apps/{app}`,
                sdkMethod: 'getUserGroupsByAppV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Processes pub sub messages for account service. Requires google service account bearer auth token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handlePubsubMessage: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({}, options = {}) {
            const localVarPath = `/v1/accounts/pubsub`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/pubsub`,
                sdkMethod: 'handlePubsubMessage',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This API is used to link two Auth0 accounts. In the context of Calm Health integration with Optum, this API links the partner member\'s enterprise account created in the Calm Health\'s Auth0 with the member\'s personal account in the Calm Health\'s Auth0.
         * @summary Link two auth0 accounts.
         * @param {string} userId User Id.
         * @param {AccountLinkAccountsRequest} [accountLinkAccountsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkAccountsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, accountLinkAccountsRequest }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('linkAccountsV1', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/link`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/link`,
                sdkMethod: 'linkAccountsV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountLinkAccountsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Performs logout function for the current session.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAccountsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('logoutAccountsV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/logout`,
                sdkMethod: 'logoutAccountsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Bulk-updates the is_suspicious flag for the given user IDs.
         * @summary Mark users as suspicious
         * @param {AccountMarkUsersSuspiciousRequest} accountMarkUsersSuspiciousRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markUsersSuspiciousV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ accountMarkUsersSuspiciousRequest }, options = {}) {
            // verify required parameter 'accountMarkUsersSuspiciousRequest' is not null or undefined
            (0, common_1.assertParamExists)('markUsersSuspiciousV1', 'accountMarkUsersSuspiciousRequest', accountMarkUsersSuspiciousRequest);
            const localVarPath = `/v1/accounts/suspicious`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/suspicious`,
                sdkMethod: 'markUsersSuspiciousV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountMarkUsersSuspiciousRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Performs partial account update
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AccountUpdateAccount} accountUpdateAccount account update
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccountsByUserIdV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, rHGApp, accountUpdateAccount, userGroup, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('patchAccountsByUserIdV1', 'userId', userId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('patchAccountsByUserIdV1', 'rHGApp', rHGApp);
            // verify required parameter 'accountUpdateAccount' is not null or undefined
            (0, common_1.assertParamExists)('patchAccountsByUserIdV1', 'accountUpdateAccount', accountUpdateAccount);
            const localVarPath = `/v1/accounts/{user_id}`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}`,
                sdkMethod: 'patchAccountsByUserIdV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountUpdateAccount, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Called by atlas-accounts after HMAC-verifying a DataGrail warehouse-access webhook. Mirrors postAdminDSRDWHDeletionV1 with request_type=access.
         * @summary Persist a DataGrail warehouse-access DSR row
         * @param {AccountDWHWebhookRequest} accountDWHWebhookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDSRDWHAccessV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ accountDWHWebhookRequest }, options = {}) {
            // verify required parameter 'accountDWHWebhookRequest' is not null or undefined
            (0, common_1.assertParamExists)('postAdminDSRDWHAccessV1', 'accountDWHWebhookRequest', accountDWHWebhookRequest);
            const localVarPath = `/v1/accounts/admin/dsr/dwh/access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/admin/dsr/dwh/access`,
                sdkMethod: 'postAdminDSRDWHAccessV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountDWHWebhookRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Called by atlas-accounts after HMAC-verifying a DataGrail warehouse-deletion webhook. Streaming-inserts one row into the compliance_dsr.dsr_requests BigQuery table with request_type=deletion and status=received. The Airflow processor DAG picks the row up asynchronously.
         * @summary Persist a DataGrail warehouse-deletion DSR row
         * @param {AccountDWHWebhookRequest} accountDWHWebhookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDSRDWHDeletionV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ accountDWHWebhookRequest }, options = {}) {
            // verify required parameter 'accountDWHWebhookRequest' is not null or undefined
            (0, common_1.assertParamExists)('postAdminDSRDWHDeletionV1', 'accountDWHWebhookRequest', accountDWHWebhookRequest);
            const localVarPath = `/v1/accounts/admin/dsr/dwh/deletion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/admin/dsr/dwh/deletion`,
                sdkMethod: 'postAdminDSRDWHDeletionV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountDWHWebhookRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Sets usergroup for accounts
         * @param {string} userId User Id.
         * @param {string} usergroup New user group where the user will be transferred to.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAccountsUsergroupV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, usergroup, rHGApp, userGroup, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('putAccountsUsergroupV1', 'userId', userId);
            // verify required parameter 'usergroup' is not null or undefined
            (0, common_1.assertParamExists)('putAccountsUsergroupV1', 'usergroup', usergroup);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('putAccountsUsergroupV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/{user_id}/usergroup/{usergroup}`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{usergroup}', encodeURIComponent(String(usergroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/usergroup/{usergroup}`,
                sdkMethod: 'putAccountsUsergroupV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Upsert the users consent state.
         * @param {string} userId User Id.
         * @param {number} consentId The consent id based on the config that needs to be acted upon.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {AccountUserConsentRequest} [accountUserConsentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserConsentByIdV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, consentId, rHGApp, userGroup, accountUserConsentRequest, }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('putUserConsentByIdV1', 'userId', userId);
            // verify required parameter 'consentId' is not null or undefined
            (0, common_1.assertParamExists)('putUserConsentByIdV1', 'consentId', consentId);
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('putUserConsentByIdV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts/{user_id}/consents/{consent_id}`
                .replace('{user_id}', encodeURIComponent(String(userId)))
                .replace('{consent_id}', encodeURIComponent(String(consentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/consents/{consent_id}`,
                sdkMethod: 'putUserConsentByIdV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountUserConsentRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Removes the photo URL from cloud storage and updates the user photo URL with the default image for the user.
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPhotoV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, userGroup }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('resetPhotoV1', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/avatar/reset`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/avatar/reset`,
                sdkMethod: 'resetPhotoV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Reset MFA for the user.
         * @param {string} userId User Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserMfalV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('resetUserMfalV1', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/mfa/reset`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/mfa/reset`,
                sdkMethod: 'resetUserMfalV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Saves user feedback
         * @summary Save user feedback
         * @param {string} userId User Id.
         * @param {AccountFeedbackRequest} [accountFeedbackRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserFeedbackV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, accountFeedbackRequest }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('saveUserFeedbackV1', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/feedbacks`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/feedbacks`,
                sdkMethod: 'saveUserFeedbackV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountFeedbackRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  Results are ordered by `created_at DESC, user_id ASC`, so successive `(limit, offset)` pages over the same dataset are disjoint and complete.
         * @summary Account search with a JSON body. Use this instead of `GET /v1/accounts` when passing more user_ids than will fit in a URL (the GET form caps out around ~200 UUIDs). Returns `totalCount` alongside the results so callers can page deterministically through large filtered sets.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AccountSearchAccountsBody} accountSearchAccountsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccountsByBodyV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, accountSearchAccountsBody }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('searchAccountsByBodyV1', 'rHGApp', rHGApp);
            // verify required parameter 'accountSearchAccountsBody' is not null or undefined
            (0, common_1.assertParamExists)('searchAccountsByBodyV1', 'accountSearchAccountsBody', accountSearchAccountsBody);
            const localVarPath = `/v1/accounts/admin/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/admin/search`,
                sdkMethod: 'searchAccountsByBodyV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountSearchAccountsBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary User account lookup. Lookup by first, last name, email or phone number that start with the search term and/or registration start and end dates. Lookup by user_ids. Note, don\'t use `q` and `user_ids` together.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [q] Search term for given name, family name, email or phone number. It should have 3 or more characters to get result.
         * @param {string} [givenName] Search term for given name. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [familyName] Search term for family name. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [email] Search term for email. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [phoneNumber] Search term for phone number. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [analyticsId] Search term for analyticsId. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [userIds] Comma separated list of user ids. Note, that you can only use &#x60;q&#x60; OR &#x60;user_ids&#x60;, but not both.
         * @param {string} [registrationStart] Beginning registration start date to search between
         * @param {string} [registrationEnd] Ending registration date to search between
         * @param {string} [limit] The number of results to return, leave out for all
         * @param {string} [offset] The offset of results to return
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccountsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, q, givenName, familyName, email, phoneNumber, analyticsId, userIds, registrationStart, registrationEnd, limit, offset, userGroup, }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('searchAccountsV1', 'rHGApp', rHGApp);
            const localVarPath = `/v1/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (givenName !== undefined) {
                localVarQueryParameter['given_name'] = givenName;
            }
            if (familyName !== undefined) {
                localVarQueryParameter['family_name'] = familyName;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (phoneNumber !== undefined) {
                localVarQueryParameter['phone_number'] = phoneNumber;
            }
            if (analyticsId !== undefined) {
                localVarQueryParameter['analytics_id'] = analyticsId;
            }
            if (userIds !== undefined) {
                localVarQueryParameter['user_ids'] = userIds;
            }
            if (registrationStart !== undefined) {
                localVarQueryParameter['registration_start'] =
                    registrationStart;
            }
            if (registrationEnd !== undefined) {
                localVarQueryParameter['registration_end'] = registrationEnd;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts`,
                sdkMethod: 'searchAccountsV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Forwards a deletion DSR for the addressed user to atlas-accounts, which submits the request to DataGrail. Accepts an admin caller (admin scope) or a member-self caller (path user_id matches the JWT subject).
         * @summary Submit a deletion DSR for the user to DataGrail.
         * @param {string} userId User Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAccountDeletionDSRV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('submitAccountDeletionDSRV1', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/dsr/delete`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/dsr/delete`,
                sdkMethod: 'submitAccountDeletionDSRV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Creates or updates account and identity data
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} body Auth0 JWT ID Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccountsV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rHGApp, body }, options = {}) {
            // verify required parameter 'rHGApp' is not null or undefined
            (0, common_1.assertParamExists)('syncAccountsV1', 'rHGApp', rHGApp);
            // verify required parameter 'body' is not null or undefined
            (0, common_1.assertParamExists)('syncAccountsV1', 'body', body);
            const localVarPath = `/v1/accounts/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/jwt';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (rHGApp != null) {
                localVarHeaderParameter['RHG-App'] = String(rHGApp);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/sync`,
                sdkMethod: 'syncAccountsV1',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Unblock user in Auth0 and remove deactivated_at flag from account
         * @summary Unblock previously blocked user
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUserV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, userGroup }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('unblockUserV1', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/unblock`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/unblock`,
                sdkMethod: 'unblockUserV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Starts Auth0 email verification job.
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccountsUserEmailV1: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ userId, userGroup }, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('verifyAccountsUserEmailV1', 'userId', userId);
            const localVarPath = `/v1/accounts/{user_id}/verifyEmail`.replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userGroup !== undefined) {
                localVarQueryParameter['user_group'] = userGroup;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/accounts/{user_id}/verifyEmail`,
                sdkMethod: 'verifyAccountsUserEmailV1',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AccountApiAxiosParamCreator = AccountApiAxiosParamCreator;
/**
 * AccountApi - functional programming interface
 */
const AccountApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AccountApiAxiosParamCreator)(configuration);
    return {
        /**
         * Block user in Auth0 and place deactivated_at flag in account
         * @summary Block user
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUserV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.blockUserV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.blockUserV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Staging only, admin only. Forwards payload to https://auth0.com/docs/api/management/v2/users/post-users
         * @summary Create a user in Auth0
         * @param {CreateAuth0UserV1IdpEnum} idp The IdP in which to create the user
         * @param {AccountCreateAuth0UserRequest} accountCreateAuth0UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuth0UserV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAuth0UserV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.createAuth0UserV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Create signed URLs where users can upload photo URL.
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhotoUploadURL(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPhotoUploadURL(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.createPhotoUploadURL']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Deletes all data related the user.
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountsByUserIdV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteAccountsByUserIdV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.deleteAccountsByUserIdV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns account information.
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByUserIdV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccountsByUserIdV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getAccountsByUserIdV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Admin endpoint to fetch feedbacks with optional filtering by user_id, feedback_type, reference_type, and reference_id.
         * @summary Return feedbacks across all users with optional filters
         * @param {string} [userId] Filter by user ID.
         * @param {GetAdminFeedbacksV1FeedbackTypeEnum} [feedbackType] Filter by feedback type.
         * @param {GetAdminFeedbacksV1ReferenceTypeEnum} [referenceType] Filter by reference type.
         * @param {string} [referenceId] Filter by reference ID.
         * @param {string} [dob] Filter by the eligibility field \&#39;dob\&#39; stored in the feedback data.
         * @param {string} [lastName] Filter by the eligibility field \&#39;last_name\&#39; stored in the feedback data (case-insensitive).
         * @param {string} [firstName] Filter by the eligibility field \&#39;first_name\&#39; stored in the feedback data (case-insensitive).
         * @param {string} [subscriberId] Filter by the eligibility field \&#39;subscriber_id\&#39; stored in the feedback data.
         * @param {string} [email] Filter by the eligibility field \&#39;email\&#39; stored in the feedback data (case-insensitive).
         * @param {number} [page] Page number (1-based). Defaults to 5 when not provided.
         * @param {number} [perPage] Number of items per page. Defaults to 10 when not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminFeedbacksV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAdminFeedbacksV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getAdminFeedbacksV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return all consents that meet the query parameters.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [cohort] The cohort to consider.
         * @param {string} [role] The role to consider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getConsentsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getConsentsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3 |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get a list of country codes
         * @param {string} [restricted] Set to true to get only restricted country codes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryCodes(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCountryCodes(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getCountryCodes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get a list of supported genders
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGendersV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getGendersV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getGendersV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns products a user belongs to.
         * @param {string} userId User Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByUserId(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProductsByUserId(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getProductsByUserId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return the users consent state.
         * @param {string} userId User Id.
         * @param {number} consentId The consent id based on the config that needs to be acted upon.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsentByIdV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserConsentByIdV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getUserConsentByIdV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return all consents for the user along with their consent state.
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsentsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserConsentsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getUserConsentsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return all feedbacks provided by the user given a feedback type
         * @param {string} userId User Id.
         * @param {GetUserFeedbacksByTypeV1FeedbackTypeEnum} feedbackType The type of feedback to return.
         * @param {number} [page] Page number (1-based). Defaults to 1 when not provided.
         * @param {number} [perPage] Number of items per page. Defaults to 10 when not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFeedbacksByTypeV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserFeedbacksByTypeV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getUserFeedbacksByTypeV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns user\'s group config.
         * @param {string} userId User Id.
         * @param {AccountApp} app App\&#39;s like mobile, web etc from the enum.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupByUserIdV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserGroupByUserIdV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getUserGroupByUserIdV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns all the group config for the provided parameters.
         * @param {AccountApp} app App\&#39;s like mobile, web etc from the enum.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupsByAppV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserGroupsByAppV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getUserGroupsByAppV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Processes pub sub messages for account service. Requires google service account bearer auth token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handlePubsubMessage(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.handlePubsubMessage(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.handlePubsubMessage']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * This API is used to link two Auth0 accounts. In the context of Calm Health integration with Optum, this API links the partner member\'s enterprise account created in the Calm Health\'s Auth0 with the member\'s personal account in the Calm Health\'s Auth0.
         * @summary Link two auth0 accounts.
         * @param {string} userId User Id.
         * @param {AccountLinkAccountsRequest} [accountLinkAccountsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkAccountsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.linkAccountsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.linkAccountsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Performs logout function for the current session.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAccountsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.logoutAccountsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.logoutAccountsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Bulk-updates the is_suspicious flag for the given user IDs.
         * @summary Mark users as suspicious
         * @param {AccountMarkUsersSuspiciousRequest} accountMarkUsersSuspiciousRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markUsersSuspiciousV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.markUsersSuspiciousV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.markUsersSuspiciousV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Performs partial account update
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AccountUpdateAccount} accountUpdateAccount account update
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccountsByUserIdV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchAccountsByUserIdV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.patchAccountsByUserIdV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Called by atlas-accounts after HMAC-verifying a DataGrail warehouse-access webhook. Mirrors postAdminDSRDWHDeletionV1 with request_type=access.
         * @summary Persist a DataGrail warehouse-access DSR row
         * @param {AccountDWHWebhookRequest} accountDWHWebhookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDSRDWHAccessV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postAdminDSRDWHAccessV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.postAdminDSRDWHAccessV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Called by atlas-accounts after HMAC-verifying a DataGrail warehouse-deletion webhook. Streaming-inserts one row into the compliance_dsr.dsr_requests BigQuery table with request_type=deletion and status=received. The Airflow processor DAG picks the row up asynchronously.
         * @summary Persist a DataGrail warehouse-deletion DSR row
         * @param {AccountDWHWebhookRequest} accountDWHWebhookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDSRDWHDeletionV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.postAdminDSRDWHDeletionV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.postAdminDSRDWHDeletionV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Sets usergroup for accounts
         * @param {string} userId User Id.
         * @param {string} usergroup New user group where the user will be transferred to.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAccountsUsergroupV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putAccountsUsergroupV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.putAccountsUsergroupV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Upsert the users consent state.
         * @param {string} userId User Id.
         * @param {number} consentId The consent id based on the config that needs to be acted upon.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {AccountUserConsentRequest} [accountUserConsentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserConsentByIdV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.putUserConsentByIdV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.putUserConsentByIdV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Removes the photo URL from cloud storage and updates the user photo URL with the default image for the user.
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPhotoV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetPhotoV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.resetPhotoV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Reset MFA for the user.
         * @param {string} userId User Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserMfalV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resetUserMfalV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.resetUserMfalV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Saves user feedback
         * @summary Save user feedback
         * @param {string} userId User Id.
         * @param {AccountFeedbackRequest} [accountFeedbackRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserFeedbackV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveUserFeedbackV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.saveUserFeedbackV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  Results are ordered by `created_at DESC, user_id ASC`, so successive `(limit, offset)` pages over the same dataset are disjoint and complete.
         * @summary Account search with a JSON body. Use this instead of `GET /v1/accounts` when passing more user_ids than will fit in a URL (the GET form caps out around ~200 UUIDs). Returns `totalCount` alongside the results so callers can page deterministically through large filtered sets.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AccountSearchAccountsBody} accountSearchAccountsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccountsByBodyV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAccountsByBodyV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.searchAccountsByBodyV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary User account lookup. Lookup by first, last name, email or phone number that start with the search term and/or registration start and end dates. Lookup by user_ids. Note, don\'t use `q` and `user_ids` together.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [q] Search term for given name, family name, email or phone number. It should have 3 or more characters to get result.
         * @param {string} [givenName] Search term for given name. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [familyName] Search term for family name. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [email] Search term for email. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [phoneNumber] Search term for phone number. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [analyticsId] Search term for analyticsId. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [userIds] Comma separated list of user ids. Note, that you can only use &#x60;q&#x60; OR &#x60;user_ids&#x60;, but not both.
         * @param {string} [registrationStart] Beginning registration start date to search between
         * @param {string} [registrationEnd] Ending registration date to search between
         * @param {string} [limit] The number of results to return, leave out for all
         * @param {string} [offset] The offset of results to return
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccountsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchAccountsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.searchAccountsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Forwards a deletion DSR for the addressed user to atlas-accounts, which submits the request to DataGrail. Accepts an admin caller (admin scope) or a member-self caller (path user_id matches the JWT subject).
         * @summary Submit a deletion DSR for the user to DataGrail.
         * @param {string} userId User Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAccountDeletionDSRV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.submitAccountDeletionDSRV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.submitAccountDeletionDSRV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Creates or updates account and identity data
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} body Auth0 JWT ID Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccountsV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.syncAccountsV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.syncAccountsV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Unblock user in Auth0 and remove deactivated_at flag from account
         * @summary Unblock previously blocked user
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUserV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unblockUserV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.unblockUserV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Starts Auth0 email verification job.
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccountsUserEmailV1(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.verifyAccountsUserEmailV1(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.verifyAccountsUserEmailV1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AccountApiFp = AccountApiFp;
/**
 * AccountApi - factory interface
 */
const AccountApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AccountApiFp)(configuration);
    return {
        /**
         * Block user in Auth0 and place deactivated_at flag in account
         * @summary Block user
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUserV1(params, options) {
            return localVarFp
                .blockUserV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Staging only, admin only. Forwards payload to https://auth0.com/docs/api/management/v2/users/post-users
         * @summary Create a user in Auth0
         * @param {CreateAuth0UserV1IdpEnum} idp The IdP in which to create the user
         * @param {AccountCreateAuth0UserRequest} accountCreateAuth0UserRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuth0UserV1(params, options) {
            return localVarFp
                .createAuth0UserV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Create signed URLs where users can upload photo URL.
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPhotoUploadURL(params, options) {
            return localVarFp
                .createPhotoUploadURL(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Deletes all data related the user.
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountsByUserIdV1(params, options) {
            return localVarFp
                .deleteAccountsByUserIdV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns account information.
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountsByUserIdV1(params, options) {
            return localVarFp
                .getAccountsByUserIdV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Admin endpoint to fetch feedbacks with optional filtering by user_id, feedback_type, reference_type, and reference_id.
         * @summary Return feedbacks across all users with optional filters
         * @param {string} [userId] Filter by user ID.
         * @param {GetAdminFeedbacksV1FeedbackTypeEnum} [feedbackType] Filter by feedback type.
         * @param {GetAdminFeedbacksV1ReferenceTypeEnum} [referenceType] Filter by reference type.
         * @param {string} [referenceId] Filter by reference ID.
         * @param {string} [dob] Filter by the eligibility field \&#39;dob\&#39; stored in the feedback data.
         * @param {string} [lastName] Filter by the eligibility field \&#39;last_name\&#39; stored in the feedback data (case-insensitive).
         * @param {string} [firstName] Filter by the eligibility field \&#39;first_name\&#39; stored in the feedback data (case-insensitive).
         * @param {string} [subscriberId] Filter by the eligibility field \&#39;subscriber_id\&#39; stored in the feedback data.
         * @param {string} [email] Filter by the eligibility field \&#39;email\&#39; stored in the feedback data (case-insensitive).
         * @param {number} [page] Page number (1-based). Defaults to 5 when not provided.
         * @param {number} [perPage] Number of items per page. Defaults to 10 when not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminFeedbacksV1(params, options) {
            return localVarFp
                .getAdminFeedbacksV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return all consents that meet the query parameters.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [cohort] The cohort to consider.
         * @param {string} [role] The role to consider.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentsV1(params, options) {
            return localVarFp
                .getConsentsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3 |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get a list of country codes
         * @param {string} [restricted] Set to true to get only restricted country codes.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryCodes(params, options) {
            return localVarFp
                .getCountryCodes(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Get a list of supported genders
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGendersV1(params, options) {
            return localVarFp
                .getGendersV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns products a user belongs to.
         * @param {string} userId User Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsByUserId(params, options) {
            return localVarFp
                .getProductsByUserId(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return the users consent state.
         * @param {string} userId User Id.
         * @param {number} consentId The consent id based on the config that needs to be acted upon.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsentByIdV1(params, options) {
            return localVarFp
                .getUserConsentByIdV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return all consents for the user along with their consent state.
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserConsentsV1(params, options) {
            return localVarFp
                .getUserConsentsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Return all feedbacks provided by the user given a feedback type
         * @param {string} userId User Id.
         * @param {GetUserFeedbacksByTypeV1FeedbackTypeEnum} feedbackType The type of feedback to return.
         * @param {number} [page] Page number (1-based). Defaults to 1 when not provided.
         * @param {number} [perPage] Number of items per page. Defaults to 10 when not provided.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserFeedbacksByTypeV1(params, options) {
            return localVarFp
                .getUserFeedbacksByTypeV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns user\'s group config.
         * @param {string} userId User Id.
         * @param {AccountApp} app App\&#39;s like mobile, web etc from the enum.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupByUserIdV1(params, options) {
            return localVarFp
                .getUserGroupByUserIdV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Returns all the group config for the provided parameters.
         * @param {AccountApp} app App\&#39;s like mobile, web etc from the enum.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroupsByAppV1(params, options) {
            return localVarFp
                .getUserGroupsByAppV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Processes pub sub messages for account service. Requires google service account bearer auth token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handlePubsubMessage(params, options) {
            return localVarFp
                .handlePubsubMessage(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * This API is used to link two Auth0 accounts. In the context of Calm Health integration with Optum, this API links the partner member\'s enterprise account created in the Calm Health\'s Auth0 with the member\'s personal account in the Calm Health\'s Auth0.
         * @summary Link two auth0 accounts.
         * @param {string} userId User Id.
         * @param {AccountLinkAccountsRequest} [accountLinkAccountsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkAccountsV1(params, options) {
            return localVarFp
                .linkAccountsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Performs logout function for the current session.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAccountsV1(params, options) {
            return localVarFp
                .logoutAccountsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Bulk-updates the is_suspicious flag for the given user IDs.
         * @summary Mark users as suspicious
         * @param {AccountMarkUsersSuspiciousRequest} accountMarkUsersSuspiciousRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markUsersSuspiciousV1(params, options) {
            return localVarFp
                .markUsersSuspiciousV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Performs partial account update
         * @param {string} userId User Id.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AccountUpdateAccount} accountUpdateAccount account update
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAccountsByUserIdV1(params, options) {
            return localVarFp
                .patchAccountsByUserIdV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Called by atlas-accounts after HMAC-verifying a DataGrail warehouse-access webhook. Mirrors postAdminDSRDWHDeletionV1 with request_type=access.
         * @summary Persist a DataGrail warehouse-access DSR row
         * @param {AccountDWHWebhookRequest} accountDWHWebhookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDSRDWHAccessV1(params, options) {
            return localVarFp
                .postAdminDSRDWHAccessV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Called by atlas-accounts after HMAC-verifying a DataGrail warehouse-deletion webhook. Streaming-inserts one row into the compliance_dsr.dsr_requests BigQuery table with request_type=deletion and status=received. The Airflow processor DAG picks the row up asynchronously.
         * @summary Persist a DataGrail warehouse-deletion DSR row
         * @param {AccountDWHWebhookRequest} accountDWHWebhookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDSRDWHDeletionV1(params, options) {
            return localVarFp
                .postAdminDSRDWHDeletionV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Sets usergroup for accounts
         * @param {string} userId User Id.
         * @param {string} usergroup New user group where the user will be transferred to.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putAccountsUsergroupV1(params, options) {
            return localVarFp
                .putAccountsUsergroupV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Upsert the users consent state.
         * @param {string} userId User Id.
         * @param {number} consentId The consent id based on the config that needs to be acted upon.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {AccountUserConsentRequest} [accountUserConsentRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putUserConsentByIdV1(params, options) {
            return localVarFp
                .putUserConsentByIdV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Removes the photo URL from cloud storage and updates the user photo URL with the default image for the user.
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPhotoV1(params, options) {
            return localVarFp
                .resetPhotoV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Reset MFA for the user.
         * @param {string} userId User Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetUserMfalV1(params, options) {
            return localVarFp
                .resetUserMfalV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Saves user feedback
         * @summary Save user feedback
         * @param {string} userId User Id.
         * @param {AccountFeedbackRequest} [accountFeedbackRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUserFeedbackV1(params, options) {
            return localVarFp
                .saveUserFeedbackV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  Results are ordered by `created_at DESC, user_id ASC`, so successive `(limit, offset)` pages over the same dataset are disjoint and complete.
         * @summary Account search with a JSON body. Use this instead of `GET /v1/accounts` when passing more user_ids than will fit in a URL (the GET form caps out around ~200 UUIDs). Returns `totalCount` alongside the results so callers can page deterministically through large filtered sets.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {AccountSearchAccountsBody} accountSearchAccountsBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccountsByBodyV1(params, options) {
            return localVarFp
                .searchAccountsByBodyV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary User account lookup. Lookup by first, last name, email or phone number that start with the search term and/or registration start and end dates. Lookup by user_ids. Note, don\'t use `q` and `user_ids` together.
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} [q] Search term for given name, family name, email or phone number. It should have 3 or more characters to get result.
         * @param {string} [givenName] Search term for given name. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [familyName] Search term for family name. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [email] Search term for email. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [phoneNumber] Search term for phone number. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [analyticsId] Search term for analyticsId. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
         * @param {string} [userIds] Comma separated list of user ids. Note, that you can only use &#x60;q&#x60; OR &#x60;user_ids&#x60;, but not both.
         * @param {string} [registrationStart] Beginning registration start date to search between
         * @param {string} [registrationEnd] Ending registration date to search between
         * @param {string} [limit] The number of results to return, leave out for all
         * @param {string} [offset] The offset of results to return
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAccountsV1(params, options) {
            return localVarFp
                .searchAccountsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Forwards a deletion DSR for the addressed user to atlas-accounts, which submits the request to DataGrail. Accepts an admin caller (admin scope) or a member-self caller (path user_id matches the JWT subject).
         * @summary Submit a deletion DSR for the user to DataGrail.
         * @param {string} userId User Id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAccountDeletionDSRV1(params, options) {
            return localVarFp
                .submitAccountDeletionDSRV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Creates or updates account and identity data
         * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
         * @param {string} body Auth0 JWT ID Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncAccountsV1(params, options) {
            return localVarFp
                .syncAccountsV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Unblock user in Auth0 and remove deactivated_at flag from account
         * @summary Unblock previously blocked user
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUserV1(params, options) {
            return localVarFp
                .unblockUserV1(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary Starts Auth0 email verification job.
         * @param {string} userId User Id.
         * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAccountsUserEmailV1(params, options) {
            return localVarFp
                .verifyAccountsUserEmailV1(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.AccountApiFactory = AccountApiFactory;
/**
 * AccountApi - object-oriented interface
 */
class AccountApi extends base_1.BaseAPI {
    /**
     * URL `/v1/accounts/{user_id}/block`
     * Block user in Auth0 and place deactivated_at flag in account
     * @summary Block user
     * @param {string} userId User Id.
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blockUserV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .blockUserV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/auth0/users`
     * Staging only, admin only. Forwards payload to https://auth0.com/docs/api/management/v2/users/post-users
     * @summary Create a user in Auth0
     * @param {CreateAuth0UserV1IdpEnum} idp The IdP in which to create the user
     * @param {AccountCreateAuth0UserRequest} accountCreateAuth0UserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAuth0UserV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .createAuth0UserV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/avatar/upload`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Create signed URLs where users can upload photo URL.
     * @param {string} userId User Id.
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPhotoUploadURL(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .createPhotoUploadURL(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Deletes all data related the user.
     * @param {string} userId User Id.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAccountsByUserIdV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .deleteAccountsByUserIdV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns account information.
     * @param {string} userId User Id.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountsByUserIdV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getAccountsByUserIdV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/admin/feedback`
     * Admin endpoint to fetch feedbacks with optional filtering by user_id, feedback_type, reference_type, and reference_id.
     * @summary Return feedbacks across all users with optional filters
     * @param {string} [userId] Filter by user ID.
     * @param {GetAdminFeedbacksV1FeedbackTypeEnum} [feedbackType] Filter by feedback type.
     * @param {GetAdminFeedbacksV1ReferenceTypeEnum} [referenceType] Filter by reference type.
     * @param {string} [referenceId] Filter by reference ID.
     * @param {string} [dob] Filter by the eligibility field \&#39;dob\&#39; stored in the feedback data.
     * @param {string} [lastName] Filter by the eligibility field \&#39;last_name\&#39; stored in the feedback data (case-insensitive).
     * @param {string} [firstName] Filter by the eligibility field \&#39;first_name\&#39; stored in the feedback data (case-insensitive).
     * @param {string} [subscriberId] Filter by the eligibility field \&#39;subscriber_id\&#39; stored in the feedback data.
     * @param {string} [email] Filter by the eligibility field \&#39;email\&#39; stored in the feedback data (case-insensitive).
     * @param {number} [page] Page number (1-based). Defaults to 5 when not provided.
     * @param {number} [perPage] Number of items per page. Defaults to 10 when not provided.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdminFeedbacksV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getAdminFeedbacksV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/consents`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Return all consents that meet the query parameters.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [cohort] The cohort to consider.
     * @param {string} [role] The role to consider.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConsentsV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getConsentsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/countryCodes`
     * https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3 |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Get a list of country codes
     * @param {string} [restricted] Set to true to get only restricted country codes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCountryCodes(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getCountryCodes(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/genders`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Get a list of supported genders
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGendersV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getGendersV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/products`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns products a user belongs to.
     * @param {string} userId User Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProductsByUserId(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getProductsByUserId(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/consents/{consent_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Return the users consent state.
     * @param {string} userId User Id.
     * @param {number} consentId The consent id based on the config that needs to be acted upon.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserConsentByIdV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getUserConsentByIdV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/consents`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Return all consents for the user along with their consent state.
     * @param {string} userId User Id.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserConsentsV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getUserConsentsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/feedbacks`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Return all feedbacks provided by the user given a feedback type
     * @param {string} userId User Id.
     * @param {GetUserFeedbacksByTypeV1FeedbackTypeEnum} feedbackType The type of feedback to return.
     * @param {number} [page] Page number (1-based). Defaults to 1 when not provided.
     * @param {number} [perPage] Number of items per page. Defaults to 10 when not provided.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserFeedbacksByTypeV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getUserFeedbacksByTypeV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/groups/apps/{app}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns user\'s group config.
     * @param {string} userId User Id.
     * @param {AccountApp} app App\&#39;s like mobile, web etc from the enum.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserGroupByUserIdV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getUserGroupByUserIdV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/groups/apps/{app}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Returns all the group config for the provided parameters.
     * @param {AccountApp} app App\&#39;s like mobile, web etc from the enum.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserGroupsByAppV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .getUserGroupsByAppV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/pubsub`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Processes pub sub messages for account service. Requires google service account bearer auth token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    handlePubsubMessage(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .handlePubsubMessage(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/link`
     * This API is used to link two Auth0 accounts. In the context of Calm Health integration with Optum, this API links the partner member\'s enterprise account created in the Calm Health\'s Auth0 with the member\'s personal account in the Calm Health\'s Auth0.
     * @summary Link two auth0 accounts.
     * @param {string} userId User Id.
     * @param {AccountLinkAccountsRequest} [accountLinkAccountsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    linkAccountsV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .linkAccountsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/logout`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Performs logout function for the current session.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logoutAccountsV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .logoutAccountsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/suspicious`
     * Bulk-updates the is_suspicious flag for the given user IDs.
     * @summary Mark users as suspicious
     * @param {AccountMarkUsersSuspiciousRequest} accountMarkUsersSuspiciousRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    markUsersSuspiciousV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .markUsersSuspiciousV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Performs partial account update
     * @param {string} userId User Id.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {AccountUpdateAccount} accountUpdateAccount account update
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchAccountsByUserIdV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .patchAccountsByUserIdV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/admin/dsr/dwh/access`
     * Called by atlas-accounts after HMAC-verifying a DataGrail warehouse-access webhook. Mirrors postAdminDSRDWHDeletionV1 with request_type=access.
     * @summary Persist a DataGrail warehouse-access DSR row
     * @param {AccountDWHWebhookRequest} accountDWHWebhookRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAdminDSRDWHAccessV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .postAdminDSRDWHAccessV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/admin/dsr/dwh/deletion`
     * Called by atlas-accounts after HMAC-verifying a DataGrail warehouse-deletion webhook. Streaming-inserts one row into the compliance_dsr.dsr_requests BigQuery table with request_type=deletion and status=received. The Airflow processor DAG picks the row up asynchronously.
     * @summary Persist a DataGrail warehouse-deletion DSR row
     * @param {AccountDWHWebhookRequest} accountDWHWebhookRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postAdminDSRDWHDeletionV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .postAdminDSRDWHDeletionV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/usergroup/{usergroup}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Sets usergroup for accounts
     * @param {string} userId User Id.
     * @param {string} usergroup New user group where the user will be transferred to.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putAccountsUsergroupV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .putAccountsUsergroupV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/consents/{consent_id}`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Upsert the users consent state.
     * @param {string} userId User Id.
     * @param {number} consentId The consent id based on the config that needs to be acted upon.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {AccountUserConsentRequest} [accountUserConsentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putUserConsentByIdV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .putUserConsentByIdV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/avatar/reset`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Removes the photo URL from cloud storage and updates the user photo URL with the default image for the user.
     * @param {string} userId User Id.
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPhotoV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .resetPhotoV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/mfa/reset`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Reset MFA for the user.
     * @param {string} userId User Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetUserMfalV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .resetUserMfalV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/feedbacks`
     * Saves user feedback
     * @summary Save user feedback
     * @param {string} userId User Id.
     * @param {AccountFeedbackRequest} [accountFeedbackRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    saveUserFeedbackV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .saveUserFeedbackV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/admin/search`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |  Results are ordered by `created_at DESC, user_id ASC`, so successive `(limit, offset)` pages over the same dataset are disjoint and complete.
     * @summary Account search with a JSON body. Use this instead of `GET /v1/accounts` when passing more user_ids than will fit in a URL (the GET form caps out around ~200 UUIDs). Returns `totalCount` alongside the results so callers can page deterministically through large filtered sets.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {AccountSearchAccountsBody} accountSearchAccountsBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAccountsByBodyV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .searchAccountsByBodyV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary User account lookup. Lookup by first, last name, email or phone number that start with the search term and/or registration start and end dates. Lookup by user_ids. Note, don\'t use `q` and `user_ids` together.
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} [q] Search term for given name, family name, email or phone number. It should have 3 or more characters to get result.
     * @param {string} [givenName] Search term for given name. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
     * @param {string} [familyName] Search term for family name. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
     * @param {string} [email] Search term for email. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
     * @param {string} [phoneNumber] Search term for phone number. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
     * @param {string} [analyticsId] Search term for analyticsId. This cannot be used with &#x60;user_ids&#x60; or &#x60;q&#x60;. It should have 3 or more characters to get result.
     * @param {string} [userIds] Comma separated list of user ids. Note, that you can only use &#x60;q&#x60; OR &#x60;user_ids&#x60;, but not both.
     * @param {string} [registrationStart] Beginning registration start date to search between
     * @param {string} [registrationEnd] Ending registration date to search between
     * @param {string} [limit] The number of results to return, leave out for all
     * @param {string} [offset] The offset of results to return
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchAccountsV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .searchAccountsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/dsr/delete`
     * Forwards a deletion DSR for the addressed user to atlas-accounts, which submits the request to DataGrail. Accepts an admin caller (admin scope) or a member-self caller (path user_id matches the JWT subject).
     * @summary Submit a deletion DSR for the user to DataGrail.
     * @param {string} userId User Id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitAccountDeletionDSRV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .submitAccountDeletionDSRV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/sync`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Creates or updates account and identity data
     * @param {string} rHGApp Format: platform&#x3D;xxx;app&#x3D;yyy;version&#x3D;a.b.c;env&#x3D;zzz;
     * @param {string} body Auth0 JWT ID Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    syncAccountsV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .syncAccountsV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/unblock`
     * Unblock user in Auth0 and remove deactivated_at flag from account
     * @summary Unblock previously blocked user
     * @param {string} userId User Id.
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unblockUserV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .unblockUserV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/accounts/{user_id}/verifyEmail`
     * |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary Starts Auth0 email verification job.
     * @param {string} userId User Id.
     * @param {string} [userGroup] User group in which the target user currently belongs to. It is not required when current user (from session0) and the target user (specified in the path param) are the same. It\&#39;s required when admins call endpoints for other users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyAccountsUserEmailV1(params, options) {
        return (0, exports.AccountApiFp)(this.configuration)
            .verifyAccountsUserEmailV1(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.AccountApi = AccountApi;
exports.CreateAuth0UserV1IdpEnum = {
    Oneid: 'oneid',
    ShreyIdp: 'shrey-idp',
};
exports.GetAdminFeedbacksV1FeedbackTypeEnum = {
    EligibilityEscalation: 'eligibility_escalation',
};
exports.GetAdminFeedbacksV1ReferenceTypeEnum = {
    PartnerId: 'partner_id',
    MemberId: 'member_id',
    PartnerAccessCode: 'partner_access_code',
};
exports.GetUserFeedbacksByTypeV1FeedbackTypeEnum = {
    EligibilityEscalation: 'eligibility_escalation',
};
//# sourceMappingURL=account-api.js.map